export const ROUTES = {
  HOME: "/",
  GUEST_PASS: "/guest-pass/:guestId"
};
